'use client';

import { getImageProps } from 'next/image';
import { useEffect } from 'react';
import type { MediaDto } from '@/lib/sanity/dto';
import { sanityImage } from '@/lib/sanity/image';

/**
 * Starts a photo as UiImage would request it at `sizes` — the same candidate, so
 * showing it later lands on a file already loaded or on its running request.
 */
export function usePreloadPhoto(image: MediaDto | undefined, sizes: string, enabled: boolean) {
    useEffect(() => {
        const src = enabled ? sanityImage.content(image) : undefined;
        if (!src) return;

        const { props } = getImageProps({ src, alt: '', fill: true, sizes });
        const preload = new window.Image();
        preload.sizes = props.sizes ?? '';
        preload.srcset = props.srcSet ?? '';
        preload.src = props.src;
    }, [image, sizes, enabled]);
}
